import { RootState, useAppDispatch, useAppSelector } from '../../store/store';
import { DeleteTrainingModel, handleToggleDeleteTrainingModel } from '../../store/mlcreator-slice/mlcreator';
import { useTranslation } from 'react-i18next';
import { enqueueSnackbar } from '../../store/app-slice/app';
import { handleNotificationVariant } from '../notifications/_common';
import DeleteDialog from '../common/DeleteDialog';

const DeleteTrainingModelDialog = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { deletingTrainingModel, deleteTraingModelDialogOpen, deleteTrainingModelBodyParams } = useAppSelector((state: RootState) => state.mlcreator);
  
    function handleClose() {
        dispatch(handleToggleDeleteTrainingModel({ isOpen: false, body: null }));
    }
  
    function handleSubmit() {
        dispatch(DeleteTrainingModel(deleteTrainingModelBodyParams.id)).then((res : any) => {
                if(res && res.payload) { 
                    dispatch(enqueueSnackbar({ 
                        message: t(`${res.payload.message}`), 
                        options: { 
                            variant: handleNotificationVariant(res.payload.success),
                            persist: !res.payload.success
                        } 
                    }))
                }
            }
        );
    }
  
    if(!deleteTrainingModelBodyParams) return <></>;

    return(
        <DeleteDialog
            open={deleteTraingModelDialogOpen} 
            title={t('DELETE_TRAINING_MODEL', { name: deleteTrainingModelBodyParams.name })} 
            bodyText={t('DELETE_TRAINING_MODEL_BODY')} 
            isLoading={deletingTrainingModel} 
            onClose={function (reason?: string): void {
                handleClose();
            }} 
            onSubmit={function (): void {
                handleSubmit();
            }} 
            cancelButtonText={t('CANCEL_BUTTON')} 
            submitButtonText={t('SUBMIT_BUTTON')}
        />
    )
}

export default DeleteTrainingModelDialog;